import React, { useState } from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Tooltip,
  useTheme,
} from "@mui/material";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { makeStyles } from "helpers/StyleHelper";
import { Link } from "react-router-dom";

type DualListWithLinksProps = {
  listItems: DualListLeftItem[];
};

export type DualListLeftItem = {
  text: string;
  rightListItems: DualListRightItem[];
  disabled?: boolean;
};

export type DualListRightItem = {
  href?: string;
  text: string;
  disabled?: boolean;
  tooltip?: string;
};

const useStyles = makeStyles(() => ({
  dualListContainer: {
    display: "flex",
    gap: "30px",
  },
  dualList: {
    width: "100%",
    minHeight: "20vh",
  },
}));

const DualListWithLinks = ({ listItems }: DualListWithLinksProps) => {
  const styles = useStyles(useTheme());
  const [selectedItem, setSelectedItem] = useState("");
  const [rightListItems, setRightListItems] = useState<DualListRightItem[]>([]);

  const renderListItemContent = (item: DualListRightItem) => {
    if (item.disabled) {
      return (
        <Tooltip title={item.tooltip}>
          <span>
            <Button disabled sx={{ textTransform: "none", padding: "0" }}>
              {item.text}
            </Button>
          </span>
        </Tooltip>
      );
    } else {
      return <ListItemText primary={item.text} />;
    }
  };

  return (
    <Box sx={styles.dualListContainer}>
      <Paper sx={styles.dualList}>
        <List dense>
          {listItems.map((item: DualListLeftItem) => {
            return (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  onClick={() => {
                    setSelectedItem(item.text);
                    setRightListItems(item.rightListItems);
                  }}
                  disabled={item.disabled}
                >
                  <ListItemText primary={item.text} />
                  {selectedItem === item.text && <ChevronRight />}
                </ListItemButton>
              </ListItem>
            );
          })}
          <ListItem />
        </List>
      </Paper>
      <Paper sx={styles.dualList}>
        <List dense>
          {rightListItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                component={Link}
                to={item.href as string}
                sx={{ cursor: item.disabled ? "default" : "pointer" }}
              >
                {renderListItemContent(item)}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default DualListWithLinks;
